import React from 'react';
import Chip from '@mui/material/Chip';

const MAP = {
  draft: { color: 'default', label: 'Draft' },
  scheduled: { color: 'info', label: 'Scheduled' },
  sending: { color: 'warning', label: 'Sending' },
  sent: { color: 'success', label: 'Sent' },
  cancelled: { color: 'default', label: 'Cancelled' },
  failed: { color: 'error', label: 'Failed' },
  queued: { color: 'info', label: 'Queued' },
  inbox_only: { color: 'secondary', label: 'Inbox Only' },
};

export default function MobileNotificationStatusChip({ status, size = 'small' }) {
  const key = String(status || '').toLowerCase();
  const meta = MAP[key] || { color: 'default', label: key || 'Unknown' };

  return <Chip size={size} color={meta.color} label={meta.label} />;
}
